import moment from "moment-hijri";

export const HIJRI_MONTHS = [
  "Muharram", "Safar", "Rabi' al-Awwal", "Rabi' al-Thani",
  "Jumada al-Ula", "Jumada al-Akhirah", "Rajab", "Sha'ban",
  "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah",
];

export function toHijri(date, offset = 0) {
  const m = moment(date).add(offset, "days");
  return {
    day: m.iDate(),
    month: m.iMonth(),
    monthName: HIJRI_MONTHS[m.iMonth()],
    year: m.iYear(),
    label: `${m.iDate()} ${HIJRI_MONTHS[m.iMonth()]} ${m.iYear()}`,
  };
}

export function hijriMonthRangeLabel(startDate, endDate, offset = 0) {
  const a = toHijri(startDate, offset);
  const b = toHijri(endDate, offset);
  if (a.month === b.month && a.year === b.year) return `${a.monthName} ${a.year}`;
  if (a.year === b.year) return `${a.monthName} – ${b.monthName} ${a.year}`;
  return `${a.monthName} ${a.year} – ${b.monthName} ${b.year}`;
}
